const trips = {
  statuses: {
    new: 'Esperando Flota',
    approved: 'Aceptado',
    canceled: 'Fechazado',
  },
  table: {
    floatingActions: {
      tooltips: {
        accept: 'Esta acción solo está disponible para viajes con estado "Esperando flota".',
        decline: 'Esta acción solo está disponible para viajes con estado "Esperando flota".',
      },
    },
    filters: {
      supplier: 'Flota',
    },
    statuses: {
      new: 'Esperando Flota',
      approved: 'Aceptado',
      canceled: 'Fechazado',
    },
    headers: {
      supplier: 'Flota',
    },
    cells: {
      supplier: {
        none: 'No Flota',
      },
      actions: {
        approve: 'Aceptar',
        remove: 'Rechazar',
      },
    },
  },
};

export default trips;
